module.exports = __webpack_public_path__ + "static/img/J-learning一覧.2257432.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/J-learning一覧.png
// module id = V3kd
// module chunks = 0